import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import { Turnstile } from '@marsidev/react-turnstile';
import { toast } from 'react-toastify';

const TurnstileCaptcha = forwardRef(
  ({ onSuccess, theme = 'light', size = 'flexible' }, ref) => {
    const turnstileRef = useRef(null);

    useImperativeHandle(ref, () => ({
      reset: () => {
        if (turnstileRef.current) {
          turnstileRef.current.reset();
        }
      }
    }));

    const onError = () => {
      toast.error(
        <span>
          Impossibile completare il captcha automatico.
          <br />
          Riprova più tardi.
        </span>
      );
    };

    return (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Turnstile
          siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
          onSuccess={onSuccess}
          onError={onError}
          ref={turnstileRef}
          options={{
            appearance: 'interaction-only',
            theme: theme,
            size: 'invisible' || size,
            feedbackEnabled: false
          }}
        />
      </div>
    );
  }
);

TurnstileCaptcha.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['light', 'dark']),
  size: PropTypes.oneOf(['normal', 'compact', 'flexible', 'invisible'])
};

export default TurnstileCaptcha;
